const MobileTelCard=({bill,type,title,parameter,selectedType,onChange})=>{
    const formattedPrice = new Intl.NumberFormat('fa-IR');
    const handleIsPayable=()=>{
        return bill && bill?.Amount.value > 0 && bill?.PayId.value.length > 5
    }
    const handleChange=(e)=>{
        if(handleIsPayable()){
            onChange(e)
        }else {

        }

    }
    return       <label className="block relative" htmlFor={type}>

        <div
            className={`p-5 bg-white relative  cursor-pointer flex justify-between flex-col ${ handleIsPayable()? 'opacity-100':'opacity-50'}   rounded-xl ${selectedType === type ? 'border-2 bg-green-100 border-green-500 ' : 'border-2 border-white'}`}>


            <div className="flex justify-between items-center">
                <strong className="  w-full  ">{title}</strong>
                <span className="text-sm">{parameter}</span>
            </div>


            <div className={`w-full mt-2 py-2 border-t ${selectedType === type ? "border-green-500" : ""}`}/>
            <div className="w-full flex text-sm items-center justify-between">

                <div
                    className={`w-5 h-5 flex justify-center items-center bg-gray-200 rounded-full ${selectedType === type && 'border-2 border-green-500'}`}>{
                    (selectedType === type) && <div className="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
                }</div>
                <input hidden id={type} value={type} checked={selectedType === type} onChange={handleChange}
                       name={type} type="radio" className="radio"/>

                <div className="flex justify-start">
                    <span className="ml-2">{bill.Amount.faName} : </span>
                    <span>{formattedPrice.format(+bill.Amount.value)}ریال</span>
                </div>
            </div>
        </div>
    </label>
}
export default MobileTelCard;